function getTranslationLanguage() {
    return page_info.localizejs_language || 'en';
}

function getTranslatedMonthName(monthNumber, short = true, capitalize = true) {
    let style = 'short';
    if (!short) {
        style = 'long';
    }
    const locale = getTranslationLanguage();
    const date = new Date(2000, monthNumber, 1)
    const formatter = new Intl.DateTimeFormat(locale, { month: style });
    const date_str = formatter.format(date);

    if (capitalize) {
        return capitalizeDate(date_str);
    }
    return date_str;
}

function capitalizeDate(date_str) {
    if (typeof date_str === 'string' && date_str.length > 2) {
        return date_str.charAt(0).toUpperCase() + date_str.slice(1)
    }
    return date_str;
}

function getElementTextWithVar(var_name, text_in_the_var, text_before_var = "", text_after_var = "") {
    var_name = escape_html(var_name);
    text_before_var = escape_html(text_before_var);
    text_in_the_var = escape_html(text_in_the_var);
    text_after_var = escape_html(text_after_var);

    return `${text_before_var}<var data-var="${var_name}">${text_in_the_var}</var>${text_after_var}`;
}

function formatClientNameWithVar(clientName) {
    const prefix = "Test Client For ";
    if (clientName.startsWith(prefix)) {
        const counselorName = clientName.slice(prefix.length).trim();
        return getElementTextWithVar('counselor_name', counselorName, prefix);
    }
    return getElementTextWithVar('client_name', clientName);
}

function formatAccessibleDate(date_str) {
    return formatDateTime(date_str.replace(/-/g, "/"), {
        weekday: 'short',
        month: 'short',
        year: 'numeric',
        day: 'numeric',
    });
}

function translateDateUsingLuxon(date, format = '', capitalize = true) {
    const locale = getTranslationLanguage();
    let dateWithLocale = date.setLocale(locale);
    if (format) {
        dateWithLocale = dateWithLocale.toFormat(format);
    }
    if (capitalize) {
        return capitalizeDate(dateWithLocale);
    }
    return dateWithLocale;
}

function getDaysOfWeekArray() {
    const locale = getTranslationLanguage();

    const baseDate = new Date(Date.UTC(2023, 0, 1)); // Jan 1, 2023, is a Sunday in UTC
    const daysOfWeek = [];

    for (let i = 0; i < 7; i++) {
        const day = new Date(baseDate.getTime() + i * 24 * 60 * 60 * 1000);
        const day_name = day.toLocaleDateString(locale, { weekday: 'short', timeZone: 'UTC' });
        daysOfWeek.push(capitalizeDate(day_name));
    }

    return daysOfWeek;
}

function getTranslationPlaceholderAudioMessage() {
    let placeholder_message = 'To write a message, first send or discard the audio message.';
    switch (getTranslationLanguage()) {
        case 'fr':
            placeholder_message = 'Pour écrire un message, envoyez ou supprimez d\'abord le message audio.';
            break;
        case 'de':
            placeholder_message = 'Um eine Nachricht zu schreiben, senden oder verwerfen Sie zunächst die Audionachricht.';
            break;
        case 'nl':
            placeholder_message = 'Om een bericht te schrijven, moet u eerst het audiobericht verzenden of verwijderen.';
            break;
        default:
            break;
    }
    return placeholder_message;
}

function getDateAtOrPipe() {
    let at = 'at';
    if (getTranslationLanguage() != 'en') {
        at = '|'
    }
    return at;
}

function sortSelectTranslation(select_id_str, ignore_first = true) {
    const select = $(select_id_str);
    const selected_value = $(select_id_str + " option:selected")[0].value;
    const children = [...select.children()];
    let desc;
    if (ignore_first) {
        desc = children.shift()
    }

    window.Localize.translate(children);
    children.sort((a,b) => {
        return a.text.localeCompare(b.text);
    });

    select[0].replaceChildren(...children);
    if (ignore_first) {
        select.prepend(desc);
    }

    $(select_id_str + " option[value='" + selected_value + "']").prop('selected', true);
}

// Checks to see if Localize exists on the page to avoid undefined errors in TC and RG
// window.Localize is not defined unless the Localize script is loaded in _head_translation.tpl
// Accepts text, HTML, or native DOM elements
function translateText(text) {
    let translatedText = text;

    if (window.Localize) {
        Localize.translate(text, function(translate) {
            translatedText = translate;
        });
    }

    return translatedText;
}

// Bootstrap's title value accepts a string or a function that returns a string
// When a string - the title value is static and will only be the value at load time.
// When a function - the title value is derived from the function and is dynamic.
// Since we worry about translation values being available on load, if we move the title value calculation to an anonymous function, we will always have the most up-to-date translation value.
// Hence why we need this instead of just using `translateText(title)` directly
function translateTooltipTitle(title) {
    return function () {
        return translateText(title)
    }
}
